<template lang="pug">
toolbar

	app-chart-zoom(
		:chart="chart"
	)
	toolbar-spacer(:full="true")

	//- Date Picker
	//- date-range-picker.date-range-picker(
	//- 	ref="picker"
	//- 	:timePicker="false"
	//- 	:showDropdowns="true"
	//- 	:autoApply="true"
	//- 	:minDate="minDate"
	//- 	:maxDate="maxDate"
	//- 	:ranges="false"
	//- 	:linkedCalendars="false"
	//- 	@update="updateDateRange"
	//- 	v-model="dateRange"
	//- 	opens="left"
	//- )
	//- 	toolbar-button.hide-phone(
	//- 		slot="input"
	//- 		slot-scope="picker"

	//- 	) {{ picker.startDate | date }} - {{ picker.endDate | date }}

	vue-date-picker.date-range-picker(
		range
		:multi-calendars="{solo: true, count: 2, static: true}"
		:enable-time-picker="false"
		:min-date="minDate"
		:max-date="maxDate"
		v-model="dateRange"
		:partial-range="false"
		position="right"
		:clearable="false"
		@update:model-value="updateDateRange"
	)
		template(
			#dp-input="{ value, onInput, onEnter, onTab, onClear, onBlur, onKeypress, onPaste, isMenuOpen }"
		)
			toolbar-button.hide-phone {{ value }}

	toolbar-spacer
	toolbar-button-group.hide-print
		toolbar-button(
			title="Download"
			icon="download"
			@click="download"
		)
		toolbar-button(
			title="Print"
			icon="print"
			@click.prevent="print"
		)
</template>

<script>
// import DateRangePicker from 'vue2-daterange-picker/dist/vue2-daterange-picker.common';
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import Toolbar from '@/common/components/Toolbar.vue';
import ToolbarSpacer from '@/common/components/ToolbarSpacer.vue';
import ToolbarButton from '@/common/components/ToolbarButton.vue';
import ToolbarButtonGroup from '@/common/components/ToolbarButtonGroup.vue';
import AppChartZoom from './AppChartZoom.vue';

import {format} from 'date-fns';
import Highcharts from 'highcharts';

export default {

	name: "AppToolbar",

	components: {
		Toolbar,
		ToolbarSpacer,
		ToolbarButton,
		ToolbarButtonGroup,
		// DateRangePicker,
		AppChartZoom,
		VueDatePicker
	},

	props: {
		"enableDownload": {
			type: Boolean,
			default: true
		},
		chart: {
			type: Object
		},
		seriesData: {
			type: Object
		},
		range: {
			type: Object
		}
	},

	data(){
		const maxDate = this.seriesData.rate30[this.seriesData.rate30.length-1].date;
		const minDate = this.seriesData.rate30[0].date;

		const startDate = new Date();
		const endDate = new Date();
		const extremes = this.chart.xAxis[0].getExtremes();
		startDate.setTime(extremes.min);
		endDate.setTime(extremes.max);

		return {
			minDate,
			maxDate,
			dateRange: [startDate, endDate]
		}
	},

	filters: {
		date (value) {
			if (!value)
				return ''
			return format(value, 'MM/dd/yyyy');
		}
	},

	created(){
		Highcharts.addEvent(
				this.chart.xAxis[0],
				'afterSetExtremes',
				(e) => this.onAfterSetExtremes() );
		this.onAfterSetExtremes();
	},

	methods: {
		download(){
			this.$emit( 'download' );
		},
		print(){
			this.$emit( 'print' );
		},
		zoom( amount ){
			this.$emit( 'zoom', amount );
		},
		updateDateRange(range){
			if( range && range[0] && range[1] ){
				this.chart.xAxis[0].setExtremes(
					range[0].getTime(),
					range[1].getTime()
				)
			}
		},
		onAfterSetExtremes(){
			const min = new Date();
			const max = new Date();
			const extremes = this.chart.xAxis[0].getExtremes();
			min.setTime(extremes.min);
			max.setTime(extremes.max);

			this.dateRange = [min,max];

			this.updatePickerMonths();

		},

		updatePickerMonths(){
			if( this.$refs.picker ){
				this.$refs.picker.changeLeftMonth({
					year: this.dateRange.startDate.getFullYear(),
					month: this.dateRange.startDate.getMonth()
				})

				this.$refs.picker.changeRightMonth({
					year: this.dateRange.endDate.getFullYear(),
					month: this.dateRange.endDate.getMonth()
				})
			}
		}
	}
}
</script>

<style lang="scss">
.date-range-picker {
	width: auto;

	:deep(.dp__arrow_top) {
		left: auto;
		right: 100px;
	}
}
</style>
